<style scoped lang="scss" type="text/scss">
    .robots-container {
        margin: -1rem 0 0 -1rem;
        display: flex;
        flex-wrap: wrap;

        .robot-item {
            margin: 1rem 0 0 1rem;
        }

        .placeholder {
            margin: 1rem 0 0 1rem;
        }
    }
</style>

<template>
    <div class="robots-container">
        <robot-item class="robot-item" :editable="false" v-for="(item, index) in data" :key="index"
                    :info="item" :index="index + 1"
        >
        </robot-item>
        <placeholder v-if="data.length === 0" class="placeholder">
            未填写机器人
        </placeholder>
    </div>
</template>

<script>
    import RobotItem from '../robot-item';
    import Placeholder from '@/components/placeholder/index';

    export default {
        name: '',
        props: {
            data: {
                type: Array,
                default: () => []
            }
        },
        components: {
            RobotItem,
            Placeholder
        },
        data () {
            return {};
        }
    };
</script>
